<template>
  <div id="graph" class="container">

  </div>
</template>

<script>
//import panZoom from "vue-panzoom";
import Viz from "viz.js";
import workerURL from "file-loader!viz.js/full.render.js";
var viz = new Viz( {workerURL});

export default {
  name: "TreeChart",
  components: {
  },
  props: {
    graphData: {
      type: String,
      default: "digraph {}",
    }
  },
  mounted() {
    viz.renderSVGElement(this.graphData).then(
        function(element) {

          let g = document.getElementById("graph");
          g.innerHTML = "";
          g.appendChild(element);
        }
    )

  },
}
</script>

<style scoped>
.container {
  width: 800px;
  min-height: 600px;
  overflow-x: scroll;
  overflow-y: auto;
  border: 2px dashed grey;
}
</style>